(function () {
  const modal = document.getElementById('QuoteModal');
  if (!modal) return;

  const form = modal.querySelector('.quote-modal__form');
  const submitBtn = modal.querySelector('.quote-modal__submit');
  const formError = modal.querySelector('[data-quote-form-error]');
  const success = modal.querySelector('[data-quote-success]');
  const title = modal.querySelector('#QuoteModal-Title');
  const intro = modal.querySelector('.quote-modal__intro');

  const cfg = {
    jsPdfUrl: modal.dataset.jspdfUrl,
    autoTableUrl: modal.dataset.autotableUrl,
    logoUrl: modal.dataset.logoUrl || '',
    currency: modal.dataset.currency || 'USD',
    salesEmail: modal.dataset.salesEmail || '',
    submitPoUrl: modal.dataset.submitPoUrl || '',
    thankYouUrl: modal.dataset.thankYouUrl || '',
    expiryDays: parseInt(modal.dataset.expiryDays || '30', 10),
  };

  const ZAPIER_WEBHOOK_URL = 'https://hooks.zapier.com/hooks/catch/1378661/4bjjk0n/';

  /* Ozobot Blue — keep in sync with --ozb-blue in quote-modal.css */
  const BLUE = [40, 38, 234];
  const DARK = [26, 26, 26];
  const MUTED = [90, 90, 96];

  /* ---- open / close ---------------------------------------------------- */
  function showForm() {
    if (success) success.hidden = true;
    form.hidden = false;
    if (title) title.hidden = false;
    if (intro) intro.hidden = false;
  }

  function showSuccess() {
    form.hidden = true;
    if (success) success.hidden = false;
    if (title) title.hidden = true;
    if (intro) intro.hidden = true;
  }

  function open() {
    showForm();
    modal.classList.add('is-open');
    document.body.classList.add('quote-modal-open');
    const first = modal.querySelector('#q_first_name');
    if (first) setTimeout(() => first.focus(), 50);
  }

  function close() {
    modal.classList.remove('is-open');
    document.body.classList.remove('quote-modal-open');
  }

  document.addEventListener('click', function (e) {
    const opener = e.target.closest('[data-quote-open]');
    if (opener) {
      e.preventDefault();
      open();
      return;
    }
    if (e.target.closest('[data-quote-close]')) {
      e.preventDefault();
      close();
    }
  });

  modal.addEventListener('click', function (e) {
    if (e.target === modal) close();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
  });

  /* ---- lazy-load jsPDF ------------------------------------------------- */
  let libsPromise;
  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      const s = document.createElement('script');
      s.src = src;
      s.onload = resolve;
      s.onerror = function () {
        reject(new Error('Failed to load ' + src));
      };
      document.head.appendChild(s);
    });
  }
  function loadLibs() {
    if (libsPromise) return libsPromise;
    libsPromise = loadScript(cfg.jsPdfUrl).then(function () {
      return loadScript(cfg.autoTableUrl);
    });
    return libsPromise;
  }

  /* ---- validation ------------------------------------------------------ */
  const REQUIRED = ['q_first_name', 'q_last_name', 'q_org', 'q_email', 'q_addr1', 'q_city', 'q_state', 'q_zip'];
  const EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

  function validate() {
    let ok = true;
    REQUIRED.forEach(function (id) {
      const el = modal.querySelector('#' + id);
      const field = el.closest('.quote-modal__field');
      if (!el.value.trim()) {
        field.classList.add('has-error');
        ok = false;
      } else {
        field.classList.remove('has-error');
      }
    });
    const email = modal.querySelector('#q_email');
    if (email.value.trim() && !EMAIL_RE.test(email.value.trim())) {
      email.closest('.quote-modal__field').classList.add('has-error');
      ok = false;
    }
    return ok;
  }

  function getData() {
    const g = function (id) {
      return modal.querySelector('#' + id).value.trim();
    };
    return {
      firstName: g('q_first_name'),
      lastName: g('q_last_name'),
      org: g('q_org'),
      email: g('q_email'),
      addr1: g('q_addr1'),
      addr2: g('q_addr2'),
      city: g('q_city'),
      state: g('q_state'),
      zip: g('q_zip'),
    };
  }

  modal.querySelectorAll('.quote-modal__input').forEach(function (input) {
    input.addEventListener('input', function () {
      const field = input.closest('.quote-modal__field');
      if (field) field.classList.remove('has-error');
    });
  });

  function showFormError(msg) {
    formError.textContent = msg;
    formError.classList.add('is-visible');
  }
  function clearFormError() {
    formError.classList.remove('is-visible');
  }

  /* ---- submit ---------------------------------------------------------- */
  form.addEventListener('submit', async function (e) {
    e.preventDefault();
    clearFormError();
    if (!validate()) return;

    const original = submitBtn.textContent;
    submitBtn.disabled = true;
    submitBtn.textContent = 'Generating…';

    try {
      const [cart] = await Promise.all([
        fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
          return r.json();
        }),
        loadLibs(),
      ]);

      if (!cart.items || cart.items.length === 0) {
        showFormError('Your cart is empty — add products before generating a quote.');
        return;
      }

      await generatePdf(cart, getData());

      if (cfg.thankYouUrl) {
        /* Send the customer to a dedicated Thank You page so the agency can add
           conversion tracking there. The PDF download has already been triggered
           by doc.save() above; wait a beat so it starts before we navigate away. */
        setTimeout(function () {
          window.location.href = cfg.thankYouUrl;
        }, 500);
      } else {
        showSuccess();
      }
    } catch (err) {
      console.error('Quote PDF generation failed:', err);
      showFormError('Sorry, something went wrong generating the PDF. Please try again.');
    } finally {
      submitBtn.disabled = false;
      submitBtn.textContent = original;
    }
  });

  /* ---- helpers --------------------------------------------------------- */
  function money(cents) {
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: cfg.currency }).format((cents || 0) / 100);
    } catch (e) {
      return '$' + ((cents || 0) / 100).toFixed(2);
    }
  }

  function pad(n, len) {
    return String(n).padStart(len || 2, '0');
  }

  function buildReference(now) {
    return (
      '' +
      now.getFullYear() +
      pad(now.getMonth() + 1) +
      pad(now.getDate()) +
      '-' +
      pad(now.getHours()) +
      pad(now.getMinutes()) +
      pad(now.getSeconds()) +
      pad(now.getMilliseconds(), 3)
    );
  }

  function fmtDate(d) {
    return d.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
  }

  /* Bulleted blue hyperlink, drawn with a matching underline. */
  function bulletLink(doc, x, baseY, text, url) {
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(10);
    doc.setTextColor(BLUE[0], BLUE[1], BLUE[2]);
    doc.text('•', x + 6, baseY);
    const linkX = x + 18;
    doc.textWithLink(text, linkX, baseY, { url: url });
    const w = doc.getTextWidth(text);
    doc.setDrawColor(BLUE[0], BLUE[1], BLUE[2]);
    doc.setLineWidth(0.6);
    doc.line(linkX, baseY + 2, linkX + w, baseY + 2);
  }

  function loadLogo() {
    return new Promise(function (resolve) {
      if (!cfg.logoUrl) {
        resolve(null);
        return;
      }
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        try {
          const canvas = document.createElement('canvas');
          canvas.width = img.naturalWidth;
          canvas.height = img.naturalHeight;
          canvas.getContext('2d').drawImage(img, 0, 0);
          resolve({ data: canvas.toDataURL('image/png'), ratio: img.naturalWidth / img.naturalHeight });
        } catch (e) {
          resolve(null);
        }
      };
      img.onerror = function () {
        resolve(null);
      };
      img.src = cfg.logoUrl;
    });
  }

  /* ---- PDF ------------------------------------------------------------- */
  async function generatePdf(cart, data) {
    const jsPDF = window.jspdf.jsPDF;
    const doc = new jsPDF({ unit: 'pt', format: 'letter' });
    const pageW = doc.internal.pageSize.getWidth();
    const margin = 40;
    const contentW = pageW - margin * 2;

    const now = new Date();
    const reference = buildReference(now);
    const created = fmtDate(now);
    const expiry = new Date(now.getTime());
    expiry.setDate(expiry.getDate() + cfg.expiryDays);

    let y = margin;

    /* Logo */
    const logo = await loadLogo();
    if (logo) {
      const lw = 120;
      const lh = lw / logo.ratio;
      doc.addImage(logo.data, 'PNG', margin, y, lw, lh);
      y += lh + 18;
    } else {
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(28);
      doc.setTextColor(0, 0, 0);
      doc.text('ozobot', margin, y + 24);
      y += 44;
    }

    /* Blue header band */
    const padX = 24;
    const padY = 22;
    const lineH = 14;
    const left = [
      { t: data.org, bold: true },
      { t: data.addr1 },
    ];
    if (data.addr2) left.push({ t: data.addr2 });
    left.push({ t: data.city + ', ' + data.state + ' ' + data.zip });
    left.push({ t: '' });
    left.push({ t: data.firstName + ' ' + data.lastName, bold: true });
    left.push({ t: data.email });

    const right = [
      { t: 'Quote created: ' + created },
      { t: 'Quote expires: ' + fmtDate(expiry) },
      { t: '' },
      { t: 'Questions? Contact: ' + cfg.salesEmail },
    ];

    const headingBlock = 26;
    const rows = Math.max(left.length, right.length);
    const bandH = padY + headingBlock + rows * lineH + padY - lineH;
    const bandTop = y;

    doc.setFillColor(BLUE[0], BLUE[1], BLUE[2]);
    doc.roundedRect(margin, bandTop, contentW, bandH, 8, 8, 'F');

    doc.setTextColor(255, 255, 255);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(20);
    doc.text(doc.splitTextToSize(data.org, contentW - padX * 2)[0], margin + padX, bandTop + padY + 16);

    const infoTop = bandTop + padY + headingBlock + 8;
    const leftX = margin + padX;
    const rightX = margin + contentW - padX;
    doc.setFontSize(10);
    left.forEach(function (ln, i) {
      if (!ln.t) return;
      doc.setFont('helvetica', ln.bold ? 'bold' : 'normal');
      doc.text(ln.t, leftX, infoTop + i * lineH);
    });
    right.forEach(function (ln, i) {
      if (!ln.t) return;
      doc.setFont('helvetica', ln.bold ? 'bold' : 'normal');
      doc.text(ln.t, rightX, infoTop + i * lineH, { align: 'right' });
    });

    y = bandTop + bandH + 28;

    /* Purchase terms & information */
    const termsPadX = 24;
    const termsTop = y;
    const termsX = margin + termsPadX;
    const oHeading = 30;
    const oTerms = 56;
    const oEmailIntro = 80;
    const oEmailLink = 100;
    const oPoIntro = 124;
    const oPoLink = 144;
    const termsH = 166;

    doc.setDrawColor(222, 222, 222);
    doc.setLineWidth(1);
    doc.roundedRect(margin, termsTop, contentW, termsH, 8, 8, 'S');

    doc.setFont('helvetica', 'bold');
    doc.setFontSize(13);
    doc.setTextColor(DARK[0], DARK[1], DARK[2]);
    doc.text('Purchase terms & information', termsX, termsTop + oHeading);

    doc.setFontSize(10);
    doc.text('Payment terms are Net 30 - Shipping costs will be added upon invoicing', termsX, termsTop + oTerms);

    doc.setFont('helvetica', 'normal');
    doc.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
    doc.text('Email a copy of your PO and sales tax exempt form (if applicable) to:', termsX, termsTop + oEmailIntro);
    bulletLink(doc, termsX, termsTop + oEmailLink, cfg.salesEmail, 'mailto:' + cfg.salesEmail);

    doc.setFont('helvetica', 'normal');
    doc.setFontSize(10);
    doc.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
    doc.text('Or, upload your PO and tax exempt form (if applicable) here:', termsX, termsTop + oPoIntro);
    bulletLink(doc, termsX, termsTop + oPoLink, 'Submit PO', cfg.submitPoUrl);

    y = termsTop + termsH + 28;

    /* Products & Services */
    doc.setTextColor(DARK[0], DARK[1], DARK[2]);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(13);
    doc.text('Products & Services', margin, y);
    y += 10;

    const body = cart.items.map(function (it) {
      let name = it.product_title || it.title || '';
      if (it.variant_title && it.variant_title !== 'Default Title') {
        name += ' - ' + it.variant_title;
      }
      return [name, it.sku || '', String(it.quantity), money(it.price), money(it.final_line_price)];
    });

    doc.autoTable({
      startY: y,
      margin: { left: margin, right: margin },
      head: [['Item & Description', 'SKU', 'Quantity', 'Unit Price', 'Total']],
      body: body,
      theme: 'plain',
      styles: {
        font: 'helvetica',
        fontSize: 10,
        textColor: [50, 50, 50],
        cellPadding: { top: 11, bottom: 11, left: 6, right: 6 },
        valign: 'middle',
      },
      headStyles: {
        textColor: BLUE,
        fontStyle: 'bold',
        lineColor: BLUE,
        lineWidth: { bottom: 1.5 },
      },
      columnStyles: {
        0: { halign: 'left', cellWidth: 'auto' },
        1: { halign: 'left', cellWidth: 80 },
        2: { halign: 'center', cellWidth: 64 },
        3: { halign: 'right', cellWidth: 78 },
        4: { halign: 'right', cellWidth: 78 },
      },
    });

    let fy = doc.lastAutoTable.finalY;
    doc.setDrawColor(BLUE[0], BLUE[1], BLUE[2]);
    doc.setLineWidth(1.5);
    doc.line(margin, fy, pageW - margin, fy);

    /* Totals */
    const labelX = pageW - margin - 220;
    const amtX = pageW - margin;
    let tyTot = fy + 26;

    doc.setFont('helvetica', 'normal');
    doc.setFontSize(11);
    doc.setTextColor(MUTED[0], MUTED[1], MUTED[2]);
    doc.text('One-time subtotal', labelX, tyTot);
    doc.text(money(cart.items_subtotal_price), amtX, tyTot, { align: 'right' });

    tyTot += 12;
    doc.setDrawColor(222, 222, 222);
    doc.setLineWidth(0.8);
    doc.line(labelX, tyTot, amtX, tyTot);

    tyTot += 24;
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(14);
    doc.setTextColor(DARK[0], DARK[1], DARK[2]);
    doc.text('Total', labelX, tyTot);
    doc.text(money(cart.total_price), amtX, tyTot, { align: 'right' });

    postToZapier(cart, data, { reference: reference, created: created, expiry: expiry });

    doc.save('Ozobot-Quote-' + reference + '.pdf');
  }

  /* ---- Zapier webhook -------------------------------------------------- */
  function postToZapier(cart, data, meta) {
    const payload = {
      reference: meta.reference,
      quote_created: meta.created,
      quote_expires: fmtDate(meta.expiry),
      first_name: data.firstName,
      last_name: data.lastName,
      organization: data.org,
      email: data.email,
      address1: data.addr1,
      address2: data.addr2,
      city: data.city,
      state: data.state,
      zip: data.zip,
      currency: cfg.currency,
      item_count: cart.item_count,
      items_subtotal: money(cart.items_subtotal_price),
      items_subtotal_cents: cart.items_subtotal_price,
      total: money(cart.total_price),
      total_cents: cart.total_price,
      line_items: cart.items.map(function (it) {
        return {
          title: it.product_title || it.title || '',
          variant: it.variant_title || '',
          sku: it.sku || '',
          quantity: it.quantity,
          unit_price: money(it.price),
          unit_price_cents: it.price,
          line_total: money(it.final_line_price),
          line_total_cents: it.final_line_price,
          product_id: it.product_id,
          variant_id: it.variant_id,
        };
      }),
    };

    /* Fire-and-forget. text/plain avoids a CORS preflight; Zapier parses the
       raw JSON body. Failures here must never block the PDF download. */
    try {
      fetch(ZAPIER_WEBHOOK_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
        body: JSON.stringify(payload),
        keepalive: true,
      }).catch(function (err) {
        console.error('Quote Zapier post failed:', err);
      });
    } catch (err) {
      console.error('Quote Zapier post failed:', err);
    }
  }
})();
